"use strict";

import "babel-polyfill";

window._ = require( 'lodash' );

let update = function ( arr, key, newval ) {
    let match = _.find( arr, key );
    if ( match ) {
        let index = _.indexOf( arr, _.find( arr, key ) );
        arr.splice( index, 1, newval );
    } else {
        arr.push( newval );
    }
};

_.mixin( { '$update': update } );

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = require( 'jquery' );
require( 'bootstrap-sass' );

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

window.Vue = require( 'vue' );

import VueResource from "vue-resource";
import VeeValidate from "vee-validate";
import Vuex from "vuex";
import VueRouter from "vue-router";
import CollectionCart from './../components/collection/collection-cart.vue';
import CollectionCartItem from './../components/collection/collection-cart-item.vue';
import CollectionGrid from './../components/collection/collect-grid';
import TimeSlot from './../components/collection/timeslot';
import CollectionForm from './../components/collection/collection-form';

Vue.use( VueResource );
Vue.use( VeeValidate );
Vue.use( Vuex );
Vue.use( VueRouter );

/**
 * Load API KEY
 */
const grotecConfig = require( './../config.js' ).default;

/**
 * We'll register a HTTP interceptor to attach the "CSRF" header to each of
 * the outgoing requests issued by this application. The CSRF middleware
 * included with Laravel will automatically verify the header's value.

 */


Vue.http.interceptors.push( function ( request, next ) {
    request.headers.set( 'X-CSRF-TOKEN', Laravel.csrfToken );
    request.headers.set( 'Authorization', 'Bearer ' + grotecConfig.api.key );
    request.headers.set( 'X-Requested-With', 'XMLHttpRequest');
    next();
} );
/**
 * The departments and products components, they're used
 * throughout the site so should be brought in here
 */

Vue.component('collection-cart', CollectionCart);
Vue.component('collection-cart-item', CollectionCartItem);
Vue.component('collection-grid', CollectionGrid);
Vue.component('timeslot', TimeSlot);
Vue.component('collection-form', CollectionForm);

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from "laravel-echo"

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'your-pusher-key'
// });
